<template>
  <div class="row main-content">
    <SocialBar/>
    <CreditoSimpleGFComponent/>
  </div>
</template>

<script>
import CreditoSimpleGFComponent from './components/CreditoSimpleGFComponent.vue';
import SocialBar from './components/SocialBar.vue';


export default {
  name: 'CreditoSimpleGF',
  components: {
    SocialBar,
    CreditoSimpleGFComponent
  }
}

</script>